
import type { TenantPluginRegister } from '@yeshuman/sdk'
import { PublicConsultReportPage } from './components/public-consult-report-page'
import { PatientDashboard, PractitionerDashboard } from './dashboards'
import { HEALTH_PAGE_ROUTES } from './routes/health-pages'
import { PatientRoutes } from './routes/patient-routes'
import { PractitionerRoutes } from './routes/practitioner-routes'

export const registerHealth: TenantPluginRegister = (app) => {
  app.focus.register({
    focus: 'patient',
    home: PatientDashboard,
    tree: PatientRoutes,
    routes: HEALTH_PAGE_ROUTES,
  })
  app.focus.register({ focus: 'practitioner', home: PractitionerDashboard, tree: PractitionerRoutes })

  app.nav.add('patient', [
    { path: '/patient', icon: 'Home', exact: true, label: 'Home' },
    { path: '/activity', icon: 'Activity' },
    { path: '/symptoms', icon: 'Stethoscope' },
    { path: '/conditions', icon: 'HeartPulse' },
    { path: '/observations', icon: 'Eye' },
    { path: '/insights', icon: 'Lightbulb' },
    { path: '/measurements', icon: 'Thermometer' },
    { path: '/therapeutics', icon: 'Pill' },
    { path: '/nutrition', icon: 'Soup' },
    { path: '/records', icon: 'FileText' },
    { path: '/consultations', icon: 'CalendarCheck' },
  ])
  app.nav.add('practitioner', [
    { path: '/practitioner', icon: 'Home', exact: true, label: 'Home' },
    { path: '/patients', icon: 'Users' },
    { path: '/consultations', icon: 'CalendarCheck' },
  ])
  app.publicShare.route({ path: '/share/consult-report/:token', element: PublicConsultReportPage })
}
